"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteNews = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var message_1 = require("../../model/message");
var service_1 = require("../../../library/base/service");
var DeleteNews = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(DeleteNews, _super);
    function DeleteNews() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '删除消息接口';
        _this.code = '101007';
        _this.desc = '删除消息接口';
        _this.requestParams = new message_1.DeleteNewsRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return DeleteNews;
}(service_1.BaseService));
exports.DeleteNews = DeleteNews;
//# sourceMappingURL=deleteNews.js.map